import kotlinx.browser.window

// Sends events to Google Analytics (GA4) via gtag.js, which is loaded in index.html. If gtag isn't
// present yet (script still loading, or the measurement id hasn't been filled in) we no-op rather
// than throw — local play must never break over analytics.
actual fun logAnalyticsEvent(name: String, params: Map<String, String>) {
    val w = window.asDynamic()
    if (w.gtag == undefined) return
    val payload = js("({})")
    for ((key, value) in params) {
        payload[key] = value
    }
    w.gtag("event", name, payload)
}
